import { Tab } from '@mui/material';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { PageHeader, QueryTabPanel, QueryTabs } from 'components';
import { BanksList } from 'features/banks';
import { P2PProvidersPage } from 'features/p2p-providers';
import { ShopList } from 'features/shop';
import { TradeMethodsPage } from 'features/trade-methods';
import { useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';

import { WalletsTab } from './Wallets';

enum CommonArchiveTabs {
  Shops = 'shops',
  Wallets = 'wallets',
  Banks = 'banks',
  TradeMethods = 'trade-methods',
  P2PProviders = 'p2p-providers',
}

export const CommonArchivePage = () => {
  // TODO: move tkeys
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.archive',
  });
  const { isAdmin, isAdminOrTechOperator } = useUser();

  return (
    <Fragment>
      <PageHeader title={t('title')} divider={false} />
      <QueryTabs tabsEnum={CommonArchiveTabs}>
        {isAdminOrTechOperator && (
          <Tab value={CommonArchiveTabs.Shops} label={t(`tabs.shops`)} />
        )}
        {isAdmin && (
          <Tab
            value={CommonArchiveTabs.Wallets}
            label={t(`tabs.${CommonArchiveTabs.Wallets}`)}
          />
        )}
        {isAdminOrTechOperator && (
          <Tab value={CommonArchiveTabs.Banks} label={t(`tabs.banks`)} />
        )}
        {isAdminOrTechOperator && (
          <Tab
            value={CommonArchiveTabs.TradeMethods}
            label={t(`tabs.trade_methods`)}
          />
        )}
        {isAdminOrTechOperator && (
          <Tab
            value={CommonArchiveTabs.P2PProviders}
            label={t(`tabs.p2p_providers`)}
          />
        )}
      </QueryTabs>
      {isAdminOrTechOperator && (
        <QueryTabPanel value={CommonArchiveTabs.Shops}>
          <ShopList archived />
        </QueryTabPanel>
      )}
      {isAdmin && (
        <QueryTabPanel value={CommonArchiveTabs.Wallets}>
          <WalletsTab />
        </QueryTabPanel>
      )}
      {isAdminOrTechOperator && (
        <QueryTabPanel value={CommonArchiveTabs.Banks}>
          <BanksList archived />
        </QueryTabPanel>
      )}
      {isAdminOrTechOperator && (
        <QueryTabPanel value={CommonArchiveTabs.TradeMethods}>
          <TradeMethodsPage archived />
        </QueryTabPanel>
      )}
      {isAdminOrTechOperator && (
        <QueryTabPanel value={CommonArchiveTabs.P2PProviders}>
          <P2PProvidersPage archived />
        </QueryTabPanel>
      )}
    </Fragment>
  );
};
